import React, { useMemo, useState } from 'react';
import {
  arrayOf,
  bool,
  func,
  oneOf,
  string
} from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  TextField,
  Tile,
  TileGroup,
} from '@one-thd/sui-atomic-components';
import { filterData } from '../helpers';

export const ModalFeedback = (
  {
    open,
    reasons,
    onClose,
    onSubmit,
    buttonsBaseId,
    title,
    textAreaPlaceholder,
    submitCTA,
    size,
  }
) => {
  const [feedbackReason, setFeedbackReason] = useState('');
  const [feedbackComment, setFeedbackComment] = useState('');
  const [canSubmit, setCanSubmit] = useState(false);
  const dataToSubmit = useMemo(() => (filterData({
    feedbackReason,
    feedbackComment
  })), [feedbackReason, feedbackComment]);

  const handleSelectReason = (__, selected) => {
    setFeedbackReason(selected);
    setCanSubmit(true);
  };

  const populateReasonOptions = () => {
    return reasons?.map(
      (item) => <Tile variant="text-only" value={item} key={item}>{item}</Tile>);
  };

  const handleChange = (event) => setFeedbackComment(event.target.value);

  const handleSubmit = () => onSubmit(dataToSubmit);

  return (
    <Modal
      open={open}
      onClose={onClose}
      size={size}
      data-testid="modal-feedback"
    >
      <ModalHeader onClose={onClose}>{title}</ModalHeader>
      <ModalBody>
        <TileGroup
          value={feedbackReason}
          onChange={handleSelectReason}
          aria-label="Reason options"
        >
          {populateReasonOptions()}
        </TileGroup>
        <TextField placeholder={textAreaPlaceholder} onChange={handleChange} multiline minRows={6} fullWidth />
      </ModalBody>
      <ModalFooter>
        <Button
          id={`${buttonsBaseId}_user-feedback_submit`}
          onClick={handleSubmit}
          disabled={!canSubmit}
          variant="primary"
          fullWidth
        >
          {submitCTA}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalFeedback.displayName = 'ModalFeedback';

ModalFeedback.propTypes = {
  open: bool.isRequired,
  reasons: arrayOf(string).isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  buttonsBaseId: string.isRequired,
  title: string,
  textAreaPlaceholder: string,
  submitCTA: string,
  size: oneOf(['sm', 'md', 'lg']),
};

ModalFeedback.defaultProps = {
  title: 'Why did you select this feedback?',
  textAreaPlaceholder: 'Add details',
  submitCTA: 'Submit',
  size: 'sm',
};
